// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"55c8eb25","124":"8b1b0bee","328":"90362303"}[chunkId] + ".chunk.js";
};